'use strict';

import { EventCodes } from '../../../App/model/event-codes';

ViewHelpService.$inject = [
	'$q',
	'$window',
	'$http',
	'$mdDialog',
	'mx.shell.Http',
	'mx.shell.Config',
	'mx.shell.View',
	'mx.shell.SidePanelService',
	'mx.SolutionBuilderAgent.ContentWidgetService',
	'mx.shell.AppsService',
	'mx.shell.EventService',
];

/**
 * @ngdoc service
 * @name mx.SolutionBuilderAgent.ViewHelpService
 * @module mx.shell
 *
 * @requires {@ref mx.shell.Config mx.shell.Http}
 * @requires {@ref mx.shell.Config mx.shell.Config}
 *
 * @description
 * A service provides methods to get/handle/display the help associated with given view.
 */
export default function ViewHelpService($q, $window, $http, $mdDialog, mxHttp, mxConfig, MxView, sidePanelService, contentWidgetService, appsService, eventService) {
	var m42OnlineHelpUrl = mxConfig.settings.restHosts.onlineHelp + '/api/kbarticle/';

	return {
		getHelpData: getHelpData,
		showMore: showMore,
		showViewHelp: showViewHelp,
		cancelViewHelp: cancelViewHelp,
		showHelpPopup: showHelpPopup,
		isHelpAvailable: isHelpAvailable,
	};

	function showViewHelp(view) {
		eventService.dispatchEvent(EventCodes.TrackViewTelemetry, {
			eventName: 'Help link opened',
			view,
		});

		if (view.helpSourceType === 3) {
			showMore(view.helpSourceType, view.helpValue);
			return;
		}

		const helpView = new MxView({
			id: 'mx-view-help',
			locals: {
				helpSourceType: view.helpSourceType,
				helpValue: view.helpValue,
				popup: true,
				calledFromSidePanel: true,
			},
			controllerAs: 'vm',
			controller: 'mx.SolutionBuilderAgent.HelpArticlePageController',
			templateUrl: 'workspaces/SolutionBuilderAgent/layouts/help-article-page/help-article-popup.html',
		});

		sidePanelService.showPopupInTab(view, helpView);
	}

	function showHelpPopup(helpContent, calledFromSidePanel) {
		var helpView = new MxView({
			id: 'mx-view-help',
			locals: {
				helpData: {
					HTML: helpContent,
				},
				isContentHelp: true,
				popup: true,
				calledFromSidePanel,
			},
			controllerAs: 'vm',
			controller: 'mx.SolutionBuilderAgent.HelpArticlePageController',
			templateUrl: 'workspaces/SolutionBuilderAgent/layouts/help-article-page/help-article-popup.html',
		});

		if (calledFromSidePanel && sidePanelService.currentView) {
			sidePanelService.showPopupInTab(sidePanelService.currentView, helpView);
		} else {
			$mdDialog.show(helpView);
		}
	}

	function cancelViewHelp(calledFromSidePanel) {
		if (calledFromSidePanel && sidePanelService.currentView) {
			sidePanelService.hidePopupInTab(sidePanelService.currentView);
		} else {
			$mdDialog.hide();
		}
	}

	function getHelpData(srcType, value) {
		var parsedValue;
		try {
			parsedValue = JSON.parse(value);
		} catch (e) {
			mx.console.error(e);
			return $q.reject(e);
		}
		var objectId = parsedValue.ObjID;

		switch (srcType) {
			case 1:
				return mxHttp.get('api/kbarticle/' + objectId + '/html').then(function (data) {
					return {
						data: data,
						hash: parsedValue.Hashtag,
						articleId: objectId,
					};
				});
			case 2:
				return $http.get(m42OnlineHelpUrl + objectId + '/html').then(function (response) {
					return {
						data: typeof response === 'object' && response.data,
						hash: parsedValue.Hashtag,
						articleId: objectId,
					};
				});
		}

		return $q.when();
	}

	function getCorrespondingUrl(srcType, value, objKBArtileValue) {
		switch (srcType) {
			case 1:
				var objectContext = {
					_type: 'SVMKBArticleType',
					_id: objKBArtileValue.ObjID,
				};
				return appsService.getCurrentApplication().then(function (app) {
					return mxConfig.settings.basePath + 'app-' + app.name + '?' + contentWidgetService.getCorrespondingUrl(undefined, undefined, objectContext, true);
				});
			case 2:
				return $q.when(mxConfig.settings.basePath + 'article/' + objKBArtileValue.ObjID);
			case 3:
				return $q.when(value);
		}
	}

	function showMore(srcType, value) {
		var objKBArtileValue = srcType === 3 ? null : JSON.parse(value || '{}') || {};
		var hashtag = (objKBArtileValue && objKBArtileValue.Hashtag) || '';

		getCorrespondingUrl(srcType, value, objKBArtileValue).then(function (correspondingUrl) {
			if (correspondingUrl) {
				var _wnd = $window.open(correspondingUrl, '_blank');
				if (_wnd && hashtag) {
					$(_wnd).ready(function (/*_jQuery*/) {
						var intervalId = setInterval(function () {
							var elem = _wnd.document.getElementsByTagName('mx-kb-solution');
							if (elem && elem.length > 0) {
								clearInterval(intervalId);
								_wnd.location.hash = hashtag;
							}
						}, 1000);
					});
				}
			}
		});
	}

	function isHelpAvailable(view) {
		return view.helpSourceType > 0;
	}
}
